module.exports = __webpack_public_path__ + "img/image (36).d9add729.jpg";